// @ts-nocheck
import { DomQuery, HtmlClassSwitch } from "./Dom";
import { getEvent } from "./Event";
import { WebPageComponent } from "./WebSite.Page.Component";

export class DropZone extends WebPageComponent {
  constructor(element) {
    super(element);
  }

  createDragEndOutsideListener() {
    return (event) => {
      this.draggingOutside.setStatus(false);
      this.draggingInside.setStatus(false);
    };
  }

  createDragEnterOutsideListener() {
    return (event) => {
      const query = new DomQuery(getEvent(event).getSource());

      if (!query.hasAncestor(this.element))
        this.draggingInside.setStatus(false);
    };
  }

  createDragLeaveOutsideListener() {
    return (event) => {
      if (event.fromElement == null)
        this.draggingOutside.setStatus(false);
    };
  }

  createDragOverOutsideListener() {
    return (event) => {
      event = getEvent(event);
      const query = new DomQuery(getEvent(event).getSource());

      if (!query.hasAncestor(this.element)) {
        event.preventDefault();

        if (event.dataTransfer.dropEffect != "move")
          event.dataTransfer.dropEffect = "none";

        this.draggingOutside.setStatus(true);
      }
      else
        event.dataTransfer.dropEffect = "move";
    };
  }

  dragEnter(event) {
    this.draggingInside.setStatus(true);
    this.draggingOutside.setStatus(false);
  }

  dragOver(event) {
    event.preventDefault();
  }

  drop(event) {
    event.preventDefault();

    const element = document.getElementsByTagName("html")[0];
    const dragEndEvent = document.createEvent("DragEvent");
    dragEndEvent.initEvent("dragend", false, false);

    element.dispatchEvent(dragEndEvent);

    if (this.canDrop(event))
      this.handleDrop(event);
  }

  initializeDropZone() {
    if (this.isEnabled()) {
      this.draggingInside = new HtmlClassSwitch(this.element, "DraggingInside");
      this.draggingInside.setStatus(false);

      this.draggingOutside = new HtmlClassSwitch(this.element, "DraggingOutside");
      this.draggingOutside.setStatus(false);

      this.dragEnterOutsideListener = this.createDragEnterOutsideListener();
      this.dragOverOutsideListener = this.createDragOverOutsideListener();
      this.dragLeaveOutsideListener = this.createDragLeaveOutsideListener();
      this.dragEndOutsideListener = this.createDragEndOutsideListener();

      this.element.ondragenter = (event) => { this.dragEnter(getEvent(event)); };
      this.element.ondragover = (event) => { this.dragOver(getEvent(event)); };
      this.element.ondrop = (event) => { this.drop(getEvent(event)); };

      const htmlElement = document.getElementsByTagName("html")[0];
      htmlElement.addEventListener("dragenter", this.dragEnterOutsideListener, true);
      htmlElement.addEventListener("dragover", this.dragOverOutsideListener, true);
      htmlElement.addEventListener("dragleave", this.dragLeaveOutsideListener, true);
      htmlElement.addEventListener("dragend", this.dragEndOutsideListener, true);
    }
  }

  isEnabled() {
    return true;
  }
}
